import {
  ONBOARDING_EMPLOYEE_FETCHING,
  ONBOARDING_EMPLOYEE_FAILED,
  ONBOARDING_EMPLOYEE_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ONBOARDING_EMPLOYEE_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case ONBOARDING_EMPLOYEE_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case ONBOARDING_EMPLOYEE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
